import React, { Children, cloneElement } from "react";

function AbonementContainer(props) {
  const { empty } = props;
  const abonements = props.children;

  function renderAbonements() {
    return Children.map(abonements, (abonement, key) => {
      const clonedElement = cloneElement(abonement, {
        key: key
      });

      return clonedElement;
    });
  }

  const emptyClassName = empty ? "abonement__container--empty" : "";

  return (
    <div className={`abonement__container ${emptyClassName}`}>
      {renderAbonements()}
    </div>
  );
}

AbonementContainer.defatulProps = {
  empty: true
};

export default AbonementContainer;
